import React from 'react';
import styled from '@emotion/styled';
import { TagButton } from '../../../../../ui';
import { KeywordButton } from './KeywordButton';
import {
	SOLID_CONTENT_WRAP_PADDING_DESKTOP,
	SOLID_CONTENT_WRAP_PADDING_MOBILE,
	SOLID_CONTENT_WRAP_PADDING_MOBILE_XL,
} from '../../../../shared/components';
import { Keyword } from '../../../domain/models';
import Responsive from '../../../../../ui/utils/Responsive';

interface IKeywordFilterButtonsProps {
	disabled?: boolean;
	currentKeyword?: Keyword;
	onClickKeywordFilter: (keyword?: Keyword) => void;
}

export const KeywordFilterButtons = ({
	disabled,
	currentKeyword,
	onClickKeywordFilter,
}: IKeywordFilterButtonsProps) => (
	<StyledKeywordFilterButtons>
		<ButtonWrap>
			<KeywordButton
				disabled={disabled}
				active={currentKeyword === undefined}
				onClick={() => onClickKeywordFilter()}
			/>
			{Object.values(Keyword).map((keyword) => (
				<KeywordButton
					key={keyword}
					keyword={keyword}
					disabled={disabled}
					active={keyword === currentKeyword}
					onClick={() => onClickKeywordFilter(keyword)}
				/>
			))}
		</ButtonWrap>
	</StyledKeywordFilterButtons>
);

const StyledKeywordFilterButtons = styled.div`
	overflow-x: auto;
	-webkit-overflow-scrolling: touch;

	margin-left: -${SOLID_CONTENT_WRAP_PADDING_DESKTOP};
	margin-right: -${SOLID_CONTENT_WRAP_PADDING_DESKTOP};
	padding-left: ${SOLID_CONTENT_WRAP_PADDING_DESKTOP};
	padding-right: ${SOLID_CONTENT_WRAP_PADDING_DESKTOP};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		margin-left: -${SOLID_CONTENT_WRAP_PADDING_MOBILE_XL};
		margin-right: -${SOLID_CONTENT_WRAP_PADDING_MOBILE_XL};
		padding-left: ${SOLID_CONTENT_WRAP_PADDING_MOBILE_XL};
		padding-right: ${SOLID_CONTENT_WRAP_PADDING_MOBILE_XL};
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobile')}) {
		margin-left: -${SOLID_CONTENT_WRAP_PADDING_MOBILE};
		margin-right: -${SOLID_CONTENT_WRAP_PADDING_MOBILE};
		padding-left: ${SOLID_CONTENT_WRAP_PADDING_MOBILE};
		padding-right: ${SOLID_CONTENT_WRAP_PADDING_MOBILE};
	}
`;

const ButtonWrap = styled.div`
	display: flex;

	${TagButton} {
		margin-right: 18px;
	}
`;
